import { InjectionToken } from '@angular/core';

export interface NgxLoadingConfig {
  fullScreenBackdrop: boolean;
  backdropBackgroundColour: string;
  backdropBorderRadius: string;
  primaryColour: string;
  secondaryColour: string;
  tertiaryColour: string;
}

export const DEFAULT_NGX_LOADING_CONFIG: NgxLoadingConfig = {
  fullScreenBackdrop: false,
  backdropBackgroundColour: 'rgba(0, 0, 0, 0.5)',
  backdropBorderRadius: '0px',
  primaryColour: '#ffffff',
  secondaryColour: '#ffffff',
  tertiaryColour: '#ffffff'
};

export const NGX_LOADING_CONFIG = new InjectionToken<Partial<NgxLoadingConfig>>('NGX_LOADING_CONFIG');
